import { Box, IconButton, Snackbar } from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import React, { SetStateAction, useState } from "react";
import { generateIframeBubbleCode } from "../../../Shared-ui/utils/Common/Common";
import { RedirectUrl } from "../../../Constant/Setting";
import SyntaxHighlighter from 'react-syntax-highlighter';
import { atomOneDark } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import variables from "../../../assets/styles/variables.module.scss";

interface MyComponentProps {
  agentId?: string;
  multiAgentId?: string;
  tabId: number;
  setTabId: React.Dispatch<SetStateAction<number>>;
}

const Embedings: React.FC<MyComponentProps> = (props) => {
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleCopy = () => {
    var code = ""
    if (props.agentId) {
      const code = generateIframeBubbleCode(RedirectUrl, props.agentId, "iframeAgent");

    }
    if (props.multiAgentId) {
      const code = generateIframeBubbleCode(RedirectUrl, props.multiAgentId, "iframeMultiAgent");
    }

    navigator.clipboard.writeText(code);
    setOpenSnackbar(true);
  }

  return (
    <>
      <Box
        sx={{
          position: "relative",
          borderRadius: "8px",
          overflow: "auto",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 1,
          }}
        >
          <IconButton
            onClick={handleCopy}
            size="small"
            sx={{
              color: "#fff",
              "&:hover": {
                color: variables.primaryColor,
              },
            }}
          >
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        </Box>
        <SyntaxHighlighter
          language="html"
          style={atomOneDark}
          customStyle={{
            margin: 0,
            padding: "16px",
            borderRadius: "8px",
            fontSize: "14px",
          }}
          wrapLongLines={true}
        >
          {generateIframeBubbleCode(RedirectUrl, props.agentId ? props.agentId : props.multiAgentId ? props.multiAgentId : "", props.agentId ? "iframeAgent" : "iframeMultiAgent")}
        </SyntaxHighlighter>
      </Box>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={() => setOpenSnackbar(false)}
        message="Code copied to clipboard"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
    </>
  );
};

export default Embedings;